import React, { useEffect, useMemo, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import {
    FaHeart,
    FaEye,
    FaExternalLinkAlt,
    FaFigma,
    FaTimes,
    FaMoon,
    FaSun,
    FaSearch,
} from "react-icons/fa";

const projectsData = [
    {
        id: 1,
        title: "JK Associations",
        category: "Banking, Software",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_220451.png?v=1782238045",
        likes: 89,
        views: 1900,
        figma: "https://figma.com",
        website: "https://shanmugam-4b482.web.app/",
    },
    {
        id: 2,
        title: "Renus Fancy Store",
        category: "Ecommerce, Fashion",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_221424.png?v=1782238486",
        likes: 124,
        views: 2450,
        figma: "https://figma.com",
        website: "https://renus-fancy-store.web.app/",
    },
    {
        id: 3,
        title: "Laxmi Beauty Parlour",
        category: "Ecommerce, Beauty, Fashion",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_221856.png?v=1782238761",
        likes: 156,
        views: 3600,
        figma: "https://figma.com",
        website: "https://lakshmi-beauty-parlour.web.app/",
    },
    {
        id: 4,
        title: "LK Education",
        category: "Education",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_222308.png?v=1782239013",
        likes: 70,
        views: 1500,
        figma: "https://figma.com",
        website: "https://lk-education.web.app/",
    },
    {
        id: 5,
        title: "SPS Spices",
        category: "Ecommerce",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_222749.png?v=1782239322",
        likes: 202,
        views: 4700,
        figma: "https://figma.com",
        website: "https://sps-spices.web.app/",
    },
    {
        id: 6,
        title: "Shreyas Boutique",
        category: "Ecommerce, Fashion, Beauty",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_223213.png?v=1782239588",
        likes: 112,
        views: 2800,
        figma: "https://figma.com",
        website: "https://shreyas-boutique.web.app/",
    },
    {
        id: 7,
        title: "Pragan Aamla Traders",
        category: "Ecommerce",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_223637.png?v=1782239819",
        likes: 17,
        views: 94,
        figma: "https://figma.com",
        website: "https://amla-traders.web.app/",
    },
    {
        id: 8,
        title: "School Management System",
        category: "Software, Education",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_224324.png?v=1782240230",
        likes: 127,
        views: 3981,
        figma: "https://figma.com",
        website: "https://student-life-os-4babb.web.app/",
    },
    {
        id: 9,
        title: "NR Logestics",
        category: "logistics",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_224628.png?v=1782240406",
        likes: 12,
        views: 139,
        figma: "https://figma.com",
        website: "https://nr-log.web.app/",
    },
    {
        id: 10,
        title: "Maps Associations",
        category: "Banking, Software",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/WhatsApp_Image_2026-06-23_at_22.56.01.jpg?v=1782240994",
        likes: 48,
        views: 956,
        figma: "https://figma.com",
        website: "https://goldloan-software.web.app/login",
    },
    {
        id: 11,
        title: "Circuitech",
        category: "Business",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_225907.png?v=1782241179",
        likes: 25,
        views: 970,
        figma: "https://figma.com",
        website: "https://circuitech-b2765.web.app/",
    },
    {
        id: 12,
        title: "Rumex Pipes",
        category: "Business",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_230119.png?v=1782241366",
        likes: 7,
        views: 344,
        figma: "https://figma.com",
        website: "https://rumexpipes.web.app/",
    },
    {
        id: 13,
        title: "Gaura Electric",
        category: "Business",
        image:
            "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Screenshot_2026-06-23_230424.png?v=1782241526",
        likes: 17,
        views: 558,
        figma: "https://figma.com",
        website: "https://gaura-electric.web.app/",
    },
];

const Webprojects = () => {
    const [activeCategory, setActiveCategory] = useState("All");
    const [selectedProject, setSelectedProject] = useState(null);
    const [darkMode, setDarkMode] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [likedProjects, setLikedProjects] = useState({});

    const getProjectCategories = (categoryString = "") =>
        categoryString
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean);

    const categories = useMemo(() => {
        const categorySet = new Set();

        projectsData.forEach((project) => {
            getProjectCategories(project.category).forEach((cat) => {
                categorySet.add(cat);
            });
        });

        return ["All", ...Array.from(categorySet)];
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1200);

        return () => clearTimeout(timer);
    }, []);

    const filteredProjects = useMemo(() => {
        let result = projectsData;

        if (activeCategory !== "All") {
            result = result.filter((project) =>
                getProjectCategories(project.category).some(
                    (cat) => cat.toLowerCase() === activeCategory.toLowerCase()
                )
            );
        }

        if (searchTerm.trim()) {
            const lowerSearch = searchTerm.toLowerCase();

            result = result.filter((project) => {
                const titleMatch = project.title
                    .toLowerCase()
                    .includes(lowerSearch);

                const categoryMatch = getProjectCategories(project.category).some(
                    (cat) => cat.toLowerCase().includes(lowerSearch)
                );

                return titleMatch || categoryMatch;
            });
        }

        return result;
    }, [activeCategory, searchTerm]);

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                setSelectedProject(null);
            }
        };

        if (selectedProject) {
            document.body.style.overflow = "hidden";
            window.addEventListener("keydown", handleEsc);
        } else {
            document.body.style.overflow = "unset";
        }

        return () => {
            document.body.style.overflow = "unset";
            window.removeEventListener("keydown", handleEsc);
        };
    }, [selectedProject]);

    const toggleLike = (projectId) => {
        setLikedProjects((prev) => ({
            ...prev,
            [projectId]: !prev[projectId],
        }));
    };

    const getDisplayLikes = (project) => {
        return likedProjects[project.id] ? project.likes + 1 : project.likes;
    };

    return (
        <Wrapper dark={darkMode}>
            <Inner>
                <TopSection>
                    <HeadingBlock>
                        <SectionLabel dark={darkMode}>Our Project Portfolio</SectionLabel>
                        <SectionTitle dark={darkMode}>
                            Selected Web Projects
                        </SectionTitle>
                        <SectionDescription dark={darkMode}>
                            Explore my recent website and software projects across
                            business, ecommerce, education, logistics and banking
                            solutions.
                        </SectionDescription>
                    </HeadingBlock>

                    <ThemeButton
                        onClick={() => setDarkMode(!darkMode)}
                        dark={darkMode}
                        aria-label="Toggle theme"
                        title="Toggle theme"
                    >
                        {darkMode ? <FaSun /> : <FaMoon />}
                    </ThemeButton>
                </TopSection>

                <FilterSection dark={darkMode}>
                    <FilterHeader>
                        <FilterTitle dark={darkMode}>Categories</FilterTitle>
                        <FilterCount dark={darkMode}>
                            {loading
                                ? "Loading..."
                                : `${filteredProjects.length} Project${
                                      filteredProjects.length > 1 ? "s" : ""
                                  }`}
                        </FilterCount>
                    </FilterHeader>

                    <SearchBarWrapper dark={darkMode}>
                        <SearchIcon dark={darkMode}>
                            <FaSearch />
                        </SearchIcon>

                        <SearchInput
                            dark={darkMode}
                            type="text"
                            placeholder="Search by project title or category..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </SearchBarWrapper>

                    <CategoryScroller>
                        <CategoryContainer>
                            {categories.map((category) => (
                                <CategoryButton
                                    key={category}
                                    type="button"
                                    active={activeCategory === category}
                                    dark={darkMode}
                                    onClick={() => setActiveCategory(category)}
                                >
                                    {category}
                                </CategoryButton>
                            ))}
                        </CategoryContainer>
                    </CategoryScroller>
                </FilterSection>

                {loading ? (
                    <MasonryGrid>
                        {Array.from({ length: 6 }).map((_, index) => (
                            <SkeletonCard key={index} dark={darkMode}>
                                <SkeletonImage dark={darkMode} />
                                <SkeletonBody>
                                    <SkeletonTags>
                                        <SkeletonTag dark={darkMode} />
                                        <SkeletonTag dark={darkMode} small />
                                    </SkeletonTags>
                                    <SkeletonTitle dark={darkMode} />
                                    <SkeletonStats>
                                        <SkeletonStat dark={darkMode} />
                                        <SkeletonStat dark={darkMode} />
                                    </SkeletonStats>
                                </SkeletonBody>
                            </SkeletonCard>
                        ))}
                    </MasonryGrid>
                ) : filteredProjects.length > 0 ? (
                    <MasonryGrid>
                        {filteredProjects.map((project) => {
                            const projectCategories = getProjectCategories(
                                project.category
                            );
                            const isLiked = !!likedProjects[project.id];

                            return (
                                <RevealCard
                                    key={project.id}
                                    dark={darkMode}
                                    as={motion.article}
                                    initial={{ opacity: 0, y: 40 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.2 }}
                                    transition={{ duration: 0.45 }}
                                >
                                    <ImageContainer>
                                        <ProjectImage
                                            src={project.image}
                                            alt={project.title}
                                            loading="lazy"
                                        />

                                        <Overlay dark={darkMode}>
                                            <OverlayTopActions>
                                                <InteractiveIconButton
                                                    type="button"
                                                    dark={darkMode}
                                                    liked={isLiked}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleLike(project.id);
                                                    }}
                                                    title="Like project"
                                                    aria-label={`Like ${project.title}`}
                                                >
                                                    <FaHeart />
                                                </InteractiveIconButton>

                                                <InteractiveIconButton
                                                    type="button"
                                                    dark={darkMode}
                                                    title="Views"
                                                    aria-label={`Views of ${project.title}`}
                                                >
                                                    <FaEye />
                                                </InteractiveIconButton>

                                                <ActionIcon
                                                    href={project.website}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    title="Visit Website"
                                                    aria-label={`Visit ${project.title} website`}
                                                >
                                                    <FaExternalLinkAlt />
                                                </ActionIcon>

                                                <ActionIcon
                                                    href={project.figma}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    title="View Figma"
                                                    aria-label={`View ${project.title} figma`}
                                                >
                                                    <FaFigma />
                                                </ActionIcon>
                                            </OverlayTopActions>

                                            <PreviewButton
                                                type="button"
                                                onClick={() =>
                                                    setSelectedProject(project)
                                                }
                                            >
                                                Preview
                                            </PreviewButton>
                                        </Overlay>
                                    </ImageContainer>

                                    <CardBody>
                                        <CategoryTagWrap>
                                            {projectCategories.map((cat) => (
                                                <CategoryTag
                                                    key={`${project.id}-${cat}`}
                                                    type="button"
                                                    dark={darkMode}
                                                    onClick={() =>
                                                        setActiveCategory(cat)
                                                    }
                                                    title={`Show ${cat} projects`}
                                                >
                                                    {cat}
                                                </CategoryTag>
                                            ))}
                                        </CategoryTagWrap>

                                        <CardFooter>
                                            <CardText>
                                                <Title dark={darkMode}>
                                                    {project.title}
                                                </Title>
                                            </CardText>

                                            <Stats>
                                                <StatButton
                                                    type="button"
                                                    dark={darkMode}
                                                    liked={isLiked}
                                                    onClick={() =>
                                                        toggleLike(project.id)
                                                    }
                                                >
                                                    <FaHeart />
                                                    <span>
                                                        {getDisplayLikes(project)}
                                                    </span>
                                                </StatButton>

                                                <StatButton type="button" dark={darkMode}>
                                                    <FaEye />
                                                    <span>{project.views}</span>
                                                </StatButton>
                                            </Stats>
                                        </CardFooter>
                                    </CardBody>
                                </RevealCard>
                            );
                        })}
                    </MasonryGrid>
                ) : (
                    <EmptyState dark={darkMode}>
                        No projects found for this search or category.
                    </EmptyState>
                )}
            </Inner>

            <AnimatePresence>
                {selectedProject && (
                    <ModalBackground
                        as={motion.div}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedProject(null)}
                    >
                        <ModalContent
                            dark={darkMode}
                            as={motion.div}
                            initial={{ opacity: 0, y: 30, scale: 0.96 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 20, scale: 0.96 }}
                            transition={{ duration: 0.25 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <CloseButton
                                onClick={() => setSelectedProject(null)}
                                dark={darkMode}
                                aria-label="Close preview"
                            >
                                <FaTimes />
                            </CloseButton>

                            <ModalGrid>
                                <ModalImageWrap dark={darkMode}>
                                    <ModalImage
                                        src={selectedProject.image}
                                        alt={selectedProject.title}
                                    />
                                </ModalImageWrap>

                                <ModalInfo>
                                    <ModalLabel dark={darkMode}>
                                        Project Preview
                                    </ModalLabel>

                                    <ModalTitle dark={darkMode}>
                                        {selectedProject.title}
                                    </ModalTitle>

                                    <ModalCategoryRow>
                                        {getProjectCategories(
                                            selectedProject.category
                                        ).map((cat) => (
                                            <ModalCategoryTag
                                                key={cat}
                                                dark={darkMode}
                                                onClick={() => {
                                                    setActiveCategory(cat);
                                                    setSelectedProject(null);
                                                }}
                                            >
                                                {cat}
                                            </ModalCategoryTag>
                                        ))}
                                    </ModalCategoryRow>

                                    <ModalStats dark={darkMode}>
                                        <ModalStatCard dark={darkMode}>
                                            <FaHeart />
                                            <div>
                                                <strong>
                                                    {getDisplayLikes(selectedProject)}
                                                </strong>
                                                <span>Likes</span>
                                            </div>
                                        </ModalStatCard>

                                        <ModalStatCard dark={darkMode}>
                                            <FaEye />
                                            <div>
                                                <strong>{selectedProject.views}</strong>
                                                <span>Views</span>
                                            </div>
                                        </ModalStatCard>
                                    </ModalStats>

                                    <ButtonGroup>
                                        <PrimaryLink
                                            href={selectedProject.website}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Visit Website
                                        </PrimaryLink>

                                        <SecondaryLink
                                            href={selectedProject.figma}
                                            target="_blank"
                                            rel="noreferrer"
                                            dark={darkMode}
                                        >
                                            View Figma
                                        </SecondaryLink>
                                    </ButtonGroup>
                                </ModalInfo>
                            </ModalGrid>
                        </ModalContent>
                    </ModalBackground>
                )}
            </AnimatePresence>
        </Wrapper>
    );
};

export default Webprojects;

/* ------------------------------ THEME TOKENS ------------------------------ */

const lightTheme = {
    bg: "#f8fafc",
    bgSecondary: "#ffffff",
    bgTertiary: "#eef2ff",
    surface: "#ffffff",
    surfaceSoft: "#f8fafc",
    border: "rgba(15, 23, 42, 0.08)",
    borderStrong: "rgba(15, 23, 42, 0.14)",
    text: "#0f172a",
    textSoft: "#475569",
    textMuted: "#64748b",
    chipBg: "#eef2ff",
    chipText: "#1e40af",
    shadow: "0 20px 60px rgba(15, 23, 42, 0.08)",
    shadowSoft: "0 10px 30px rgba(15, 23, 42, 0.06)",
    overlayCard:
        "linear-gradient(180deg, rgba(15,23,42,0.08) 0%, rgba(15,23,42,0.82) 100%)",
};

const darkTheme = {
    bg: "#020617",
    bgSecondary: "#0f172a",
    bgTertiary: "#111c34",
    surface: "#0f172a",
    surfaceSoft: "#111827",
    border: "rgba(255, 255, 255, 0.08)",
    borderStrong: "rgba(255, 255, 255, 0.14)",
    text: "#f8fafc",
    textSoft: "#cbd5e1",
    textMuted: "#94a3b8",
    chipBg: "rgba(37, 99, 235, 0.16)",
    chipText: "#bfdbfe",
    shadow: "0 20px 60px rgba(0, 0, 0, 0.45)",
    shadowSoft: "0 12px 30px rgba(0, 0, 0, 0.28)",
    overlayCard:
        "linear-gradient(180deg, rgba(2,6,23,0.10) 0%, rgba(2,6,23,0.88) 100%)",
};

const getTheme = (dark) => (dark ? darkTheme : lightTheme);

/* -------------------------------- STYLES -------------------------------- */

const Wrapper = styled.section`
    width: 100%;
    min-height: 100vh;
    padding: 80px 20px;
    background: ${({ dark }) => getTheme(dark).bg};
    color: ${({ dark }) => getTheme(dark).text};
    transition: background 0.3s ease, color 0.3s ease;

    @media (max-width: 768px) {
        padding: 60px 14px;
    }
`;

const Inner = styled.div`
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
`;

const TopSection = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 28px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

const HeadingBlock = styled.div`
    flex: 1;
`;

const SectionLabel = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    border-radius: 999px;
    margin-bottom: 14px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    background: ${({ dark }) => getTheme(dark).chipBg};
    color: ${({ dark }) => getTheme(dark).chipText};
    border: 1px solid ${({ dark }) => getTheme(dark).border};
`;

const SectionTitle = styled.h2`
    margin: 0;
    font-size: clamp(28px, 4vw, 44px);
    line-height: 1.15;
    font-weight: 800;
    color: ${({ dark }) => getTheme(dark).text};
`;

const SectionDescription = styled.p`
    margin: 14px 0 0;
    max-width: 780px;
    font-size: 15px;
    line-height: 1.8;
    color: ${({ dark }) => getTheme(dark).textSoft};

    @media (max-width: 768px) {
        font-size: 14px;
        line-height: 1.7;
    }
`;

const ThemeButton = styled.button`
    flex-shrink: 0;
    width: 52px;
    height: 52px;
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    background: ${({ dark }) => getTheme(dark).surface};
    color: ${({ dark }) => getTheme(dark).text};
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    box-shadow: ${({ dark }) => getTheme(dark).shadowSoft};
    transition: all 0.25s ease;

    &:hover {
        transform: translateY(-2px);
    }

    @media (max-width: 768px) {
        width: 48px;
        height: 48px;
        align-self: flex-end;
    }
`;

const FilterSection = styled.div`
    background: ${({ dark }) => getTheme(dark).surface};
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    border-radius: 24px;
    padding: 20px;
    margin-bottom: 28px;
    box-shadow: ${({ dark }) => getTheme(dark).shadowSoft};

    @media (max-width: 768px) {
        padding: 16px;
        border-radius: 20px;
    }
`;

const FilterHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;

    @media (max-width: 576px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const FilterTitle = styled.h3`
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: ${({ dark }) => getTheme(dark).text};
`;

const FilterCount = styled.span`
    font-size: 14px;
    color: ${({ dark }) => getTheme(dark).textMuted};
`;

const SearchBarWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-bottom: 18px;
`;

const SearchIcon = styled.div`
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: ${({ dark }) => getTheme(dark).textMuted};
    font-size: 14px;
    pointer-events: none;
`;

const SearchInput = styled.input`
    width: 100%;
    height: 52px;
    border-radius: 16px;
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    background: ${({ dark }) => getTheme(dark).surfaceSoft};
    color: ${({ dark }) => getTheme(dark).text};
    padding: 0 16px 0 46px;
    font-size: 15px;
    outline: none;
    transition: all 0.25s ease;

    &::placeholder {
        color: ${({ dark }) => getTheme(dark).textMuted};
    }

    &:focus {
        border-color: #2563eb;
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
    }
`;

const CategoryScroller = styled.div`
    width: 100%;
    overflow-x: auto;
    padding-bottom: 4px;

    &::-webkit-scrollbar {
        height: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(148, 163, 184, 0.35);
        border-radius: 999px;
    }
`;

const CategoryContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    min-width: max-content;

    @media (max-width: 768px) {
        flex-wrap: nowrap;
        padding-bottom: 4px;
    }
`;

const CategoryButton = styled.button`
    border: 1px solid
        ${({ active, dark }) =>
            active ? "transparent" : getTheme(dark).border};
    padding: 12px 18px;
    border-radius: 999px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.25s ease;
    white-space: nowrap;

    background: ${({ active, dark }) =>
        active
            ? "linear-gradient(135deg, #2563eb, #1d4ed8)"
            : getTheme(dark).surfaceSoft};

    color: ${({ active, dark }) =>
        active ? "#ffffff" : getTheme(dark).text};

    box-shadow: ${({ active }) =>
        active ? "0 10px 30px rgba(37, 99, 235, 0.28)" : "none"};

    &:hover {
        transform: translateY(-2px);
    }

    @media (max-width: 768px) {
        padding: 11px 16px;
        font-size: 13px;
    }
`;

const MasonryGrid = styled.div`
    column-count: 3;
    column-gap: 24px;

    @media (max-width: 1200px) {
        column-count: 2;
    }

    @media (max-width: 700px) {
        column-count: 1;
    }
`;

const RevealCard = styled.div`
    break-inside: avoid;
    margin-bottom: 24px;
    border-radius: 24px;
    overflow: hidden;
    background: ${({ dark }) => getTheme(dark).surface};
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    box-shadow: ${({ dark }) => getTheme(dark).shadowSoft};
    transition: transform 0.25s ease, box-shadow 0.25s ease;

    &:hover {
        transform: translateY(-4px);
        box-shadow: ${({ dark }) => getTheme(dark).shadow};
    }

    @media (max-width: 768px) {
        border-radius: 20px;
    }
`;

const ImageContainer = styled.div`
    position: relative;
    overflow: hidden;
`;

const ProjectImage = styled.img`
    width: 100%;
    display: block;
    object-fit: cover;
    transition: transform 0.45s ease;

    ${RevealCard}:hover & {
        transform: scale(1.03);
    }
`;

const Overlay = styled.div`
    position: absolute;
    inset: 0;
    background: ${({ dark }) => getTheme(dark).overlayCard};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px;
    opacity: 0;
    transition: 0.3s ease;

    ${RevealCard}:hover & {
        opacity: 1;
    }

    @media (max-width: 768px) {
        opacity: 1;
    }
`;

const OverlayTopActions = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
`;

const iconGlassBase = css`
    width: 46px;
    height: 46px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(255, 255, 255, 0.14);
    backdrop-filter: blur(8px);
    color: #ffffff;
    transition: transform 0.25s ease, background 0.25s ease, color 0.25s ease;

    &:hover {
        transform: translateY(-2px) scale(1.04);
        background: rgba(255, 255, 255, 0.24);
    }

    @media (max-width: 768px) {
        width: 42px;
        height: 42px;
        border-radius: 12px;
    }
`;

const InteractiveIconButton = styled.button`
    ${iconGlassBase};
    border: 1px solid
        ${({ liked }) =>
            liked ? "rgba(244, 63, 94, 0.35)" : "rgba(255,255,255,0.18)"};
    background: ${({ liked }) =>
        liked ? "rgba(244, 63, 94, 0.18)" : "rgba(255,255,255,0.14)"};

    svg {
        color: ${({ liked }) => (liked ? "#fb7185" : "#ffffff")};
    }
`;

const ActionIcon = styled.a`
    ${iconGlassBase};
`;

const PreviewButton = styled.button`
    border: none;
    padding: 12px 22px;
    border-radius: 999px;
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    color: #ffffff;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    box-shadow: 0 12px 30px rgba(37, 99, 235, 0.28);
    transition: transform 0.25s ease;

    &:hover {
        transform: translateY(-2px);
    }
`;

const CardBody = styled.div`
    padding: 18px 18px 20px;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

const CategoryTagWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
`;

const CategoryTag = styled.button`
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    background: ${({ dark }) => getTheme(dark).chipBg};
    color: ${({ dark }) => getTheme(dark).chipText};
    padding: 8px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
        transform: translateY(-1px);
    }
`;

const CardFooter = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: 576px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const CardText = styled.div`
    flex: 1;
    min-width: 0;
`;

const Title = styled.h3`
    margin: 0;
    font-size: 20px;
    line-height: 1.35;
    font-weight: 800;
    color: ${({ dark }) => getTheme(dark).text};
    word-break: break-word;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

const Stats = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
`;

const StatButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 14px;
    background: ${({ dark, liked }) =>
        liked ? "rgba(244, 63, 94, 0.12)" : getTheme(dark).surfaceSoft};
    border: 1px solid
        ${({ dark, liked }) =>
            liked ? "rgba(244, 63, 94, 0.18)" : getTheme(dark).border};
    color: ${({ dark }) => getTheme(dark).textSoft};
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.25s ease;

    svg {
        color: ${({ liked, dark }) =>
            liked ? "#fb7185" : dark ? "#93c5fd" : "#2563eb"};
        flex-shrink: 0;
    }

    &:first-child svg {
        color: ${({ liked }) => (liked ? "#fb7185" : "#e11d48")};
    }

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
    }
`;

const EmptyState = styled.div`
    padding: 40px 20px;
    text-align: center;
    border-radius: 20px;
    background: ${({ dark }) => getTheme(dark).surface};
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    color: ${({ dark }) => getTheme(dark).textSoft};
`;

/* ----------------------------- SKELETON UI ----------------------------- */

const shimmer = keyframes`
  0% {
    background-position: -300px 0;
  }
  100% {
    background-position: calc(300px + 100%) 0;
  }
`;

const skeletonBase = css`
    background: linear-gradient(
        90deg,
        rgba(148, 163, 184, 0.12) 25%,
        rgba(148, 163, 184, 0.22) 37%,
        rgba(148, 163, 184, 0.12) 63%
    );
    background-size: 400px 100%;
    animation: ${shimmer} 1.3s ease-in-out infinite;
`;

const SkeletonCard = styled.div`
    break-inside: avoid;
    margin-bottom: 24px;
    border-radius: 24px;
    overflow: hidden;
    background: ${({ dark }) => getTheme(dark).surface};
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    box-shadow: ${({ dark }) => getTheme(dark).shadowSoft};
`;

const SkeletonImage = styled.div`
    ${skeletonBase};
    width: 100%;
    height: 260px;

    @media (max-width: 768px) {
        height: 220px;
    }
`;

const SkeletonBody = styled.div`
    padding: 18px;
`;

const SkeletonTags = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
`;

const SkeletonTag = styled.div`
    ${skeletonBase};
    width: ${({ small }) => (small ? "70px" : "110px")};
    height: 32px;
    border-radius: 999px;
`;

const SkeletonTitle = styled.div`
    ${skeletonBase};
    width: 70%;
    height: 24px;
    border-radius: 10px;
    margin-bottom: 18px;
`;

const SkeletonStats = styled.div`
    display: flex;
    gap: 10px;
`;

const SkeletonStat = styled.div`
    ${skeletonBase};
    width: 90px;
    height: 42px;
    border-radius: 14px;
`;

/* ------------------------------ MODAL STYLES ----------------------------- */

const ModalBackground = styled.div`
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(2, 6, 23, 0.78);
    backdrop-filter: blur(8px);
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        padding: 12px;
        align-items: flex-end;
    }
`;

const ModalContent = styled.div`
    width: min(1100px, 100%);
    max-height: 92vh;
    overflow-y: auto;
    position: relative;
    background: ${({ dark }) => getTheme(dark).surface};
    color: ${({ dark }) => getTheme(dark).text};
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    border-radius: 28px;
    box-shadow: ${({ dark }) => getTheme(dark).shadow};
    padding: 24px;

    @media (max-width: 768px) {
        max-height: 94vh;
        padding: 16px;
        border-radius: 24px 24px 0 0;
    }
`;

const CloseButton = styled.button`
    position: sticky;
    top: 0;
    margin-left: auto;
    display: flex;
    width: 46px;
    height: 46px;
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    background: ${({ dark }) => getTheme(dark).surfaceSoft};
    color: ${({ dark }) => getTheme(dark).text};
    border-radius: 14px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    z-index: 2;
    transition: transform 0.2s ease;
    float: right;

    &:hover {
        transform: rotate(90deg);
    }
`;

const ModalGrid = styled.div`
    display: grid;
    grid-template-columns: 1.15fr 0.85fr;
    gap: 24px;
    clear: both;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
`;

const ModalImageWrap = styled.div`
    background: ${({ dark }) => getTheme(dark).surfaceSoft};
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    border-radius: 24px;
    overflow: hidden;
`;

const ModalImage = styled.img`
    width: 100%;
    display: block;
`;

const ModalInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

const ModalLabel = styled.span`
    display: inline-block;
    margin-bottom: 12px;
    color: ${({ dark }) => getTheme(dark).chipText};
    font-weight: 700;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

const ModalTitle = styled.h2`
    margin: 0 0 18px;
    font-size: clamp(24px, 3vw, 34px);
    line-height: 1.2;
    color: ${({ dark }) => getTheme(dark).text};
`;

const ModalCategoryRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 22px;
`;

const ModalCategoryTag = styled.button`
    border: 1px solid ${({ dark }) => getTheme(dark).border};
    background: ${({ dark }) => getTheme(dark).chipBg};
    color: ${({ dark }) => getTheme(dark).chipText};
    padding: 10px 14px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
`;

const ModalStats = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-bottom: 24px;

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

const ModalStatCard = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px;
    border-radius: 18px;
    background: ${({ dark }) => getTheme(dark).surfaceSoft};
    border: 1px solid ${({ dark }) => getTheme(dark).border};

    svg {
        font-size: 18px;
        color: ${({ dark }) => (dark ? "#93c5fd" : "#2563eb")};
        flex-shrink: 0;
    }

    &:first-child svg {
        color: #fb7185;
    }

    div {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    strong {
        font-size: 18px;
        color: ${({ dark }) => getTheme(dark).text};
    }

    span {
        font-size: 13px;
        color: ${({ dark }) => getTheme(dark).textMuted};
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: auto;

    @media (max-width: 576px) {
        flex-direction: column;
    }
`;

const linkButtonBase = css`
    text-decoration: none;
    padding: 14px 20px;
    border-radius: 16px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 50px;
    transition: transform 0.25s ease, box-shadow 0.25s ease;

    &:hover {
        transform: translateY(-2px);
    }
`;

const PrimaryLink = styled.a`
    ${linkButtonBase};
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #ffffff;
    box-shadow: 0 12px 30px rgba(37, 99, 235, 0.28);
`;

const SecondaryLink = styled.a`
    ${linkButtonBase};
    background: ${({ dark }) => getTheme(dark).surfaceSoft};
    color: ${({ dark }) => getTheme(dark).text};
    border: 1px solid ${({ dark }) => getTheme(dark).border};
`;